import { useContext } from 'react';
import {
  DetailContext,
  abortableFetch,
  useEventCallback,
} from '@eas/common-web';
import { EsFileRegulation } from '@models';
import { EsFileState, EvidenceApiUrl, RegulationEntityType } from '@enums';

export function useEditRegulationDialog() {
  const { source } = useContext(DetailContext);

  const callApi = useEventCallback(
    (
      esFileId: string,
      regulations: EsFileRegulation[],
      updateClosed = source.data?.state === EsFileState.CLOSED
    ) => {
      return abortableFetch(
        `${EvidenceApiUrl.ES_FILES}/${esFileId}/regulation${
          updateClosed ? '/update-closed' : ''
        }`,
        {
          method: 'PUT',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify(
            regulations.map((regulation) => {
              const { sectionOrArticlePart, ...rest } = regulation;

              return regulation.type === RegulationEntityType.ARTICLE
                ? { ...rest, article: sectionOrArticlePart }
                : { ...rest, sectionSign: sectionOrArticlePart };
            })
          ),
        }
      );
    }
  );

  return {
    callApi,
  };
}
